import { CTLiveApi } from 'ctlive-api';
import { RESTRequest, BaseApi, Ajaxer, DataRouter, LazySubject } from 'syracuse-js';
import { configs } from 'configs';

module.exports = new CTLiveApi(
  new DataRouter(
    new BaseApi(configs.apiBaseUrl, new Ajaxer()),
    new RESTRequest(null, null, null), new LazySubject()
  )
);



// WEBPACK FOOTER //
// ./ctliveapi-configured.js